export const
    back_arrow = require('./back_arrow.svg'),
    back_arrow_white = require('./back_arrow_white.svg'),
    btn_close_x = require('./btn-close-x.svg'),
    checkmark_white = require('./checkmark_white.svg'),
    info = require('./info_icon.svg'),
    x_icon = require('./x_icon.svg')